import getUsageForProfile from "./getUsageForProfile"
import usageProfilesDetailed from "@/constants/usageEstimation/usageProfilesDetailed"
import usageProfilesOfgem from "@/constants/usageEstimation/usageProfilesOfgem.map"
import solarPanelTypes from "@/constants/usageEstimation/solarPanelTypes"
import electricVehicleTypes from "@/constants/usageEstimation/electricVehicleTypes"
import {
  CookingFuel,
  HeatingFuel,
  IUsageAdjustment,
  BasicUsageIntensity,
} from "./types"

class UsageEstimationServiceClass {
  getOfgemUsageProfiles() {
    return usageProfilesOfgem
  }
  getSolarPanelTypes() {
    return solarPanelTypes
  }
  getElectricVehicleTypes() {
    return electricVehicleTypes
  }
  getBasicUsageEstimation(
    userType: BasicUsageIntensity,
    usageDetails: IUsageAdjustment = {},
  ) {
    const usageProfile = this.getOfgemUsageProfiles()[userType]

    return getUsageForProfile(usageProfile, usageDetails)
  }
  getDetailedUsageEstimation(
    cooking: CookingFuel,
    heating: HeatingFuel,
    bedrooms: number,
    usageDetails: IUsageAdjustment = {},
  ) {
    const usageProfile = usageProfilesDetailed.find(
      (profile) =>
        HeatingFuel[profile.heating] === heating &&
        CookingFuel[profile.cooking] === cooking &&
        profile.bedrooms === bedrooms,
    )
    if (!usageProfile) throw new Error("Detailed usage profile not found")

    return getUsageForProfile(usageProfile, usageDetails)
  }
  getOfgemBandForEstimation(
    refinedProfile,
    { isElectricity, hasTwoRateElectricity },
  ) {
    const ofgemProfiles = UsageEstimationService.getOfgemUsageProfiles()
    let estimation = refinedProfile.electricity

    if (isElectricity && hasTwoRateElectricity) {
      estimation =
        refinedProfile.electricityDay + refinedProfile.electricityNight
    } else if (!isElectricity) {
      estimation = refinedProfile.gas
    }

    const usageAveragesForMeter = Object.entries(ofgemProfiles)
      .map(([category, usageProfile]) => {
        let usage = usageProfile.electricityUsage
        if (isElectricity && hasTwoRateElectricity) {
          usage = usageProfile.electricityTwoRateUsage
        } else if (!isElectricity) {
          usage = usageProfile.gasUsage
        }

        return {
          usage,
          category,
        }
      })
      .sort((band1, band2) => band1.usage - band2.usage)

    const bandMatchingEstimation =
      usageAveragesForMeter.find((band, index) => {
        const nextBand = usageAveragesForMeter[index + 1]
        const bandSpread = nextBand ? (nextBand.usage - band.usage) / 2 : 0
        return estimation <= band.usage + bandSpread
      }) ?? usageAveragesForMeter.pop() // if estimation exceeds the largest band, return the largest

    return bandMatchingEstimation?.category
  }
}

export const UsageEstimationService = new UsageEstimationServiceClass()
